<template>
  <v-sheet :color="$vuetify.theme.dark.secondary">
    <div v-if="hasHeader" class="header">
      <slot name="header">Header</slot>
    </div>
    <div class="body">
      <slot name="body">Main Content</slot>
    </div>
    <div v-if="hasFooter" class="footer px-3 py-2">
      <slot name="footer" />
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'sheet-wrapper',
  props: {
    teamInfo: Object
  },
  computed: {
    hasFooter() {
      return this.$slots.footer || false
    },
    hasHeader() {
      return this.$slots.header || false
    }
  }
}
</script>

<style lang="scss" scoped>
.sheet-wrapper {
  border-radius: 5px;
}
.header {
  border-bottom: 1px solid $primary-background-color;
}
.footer {
  border-top: 1px solid $primary-background-color;
}
</style>
